import { __assign } from "tslib";
import React from 'react';
import { IMaskInput } from 'react-imask';
import { MaskedRange } from 'imask';
import { IMaskMixin } from 'react-imask';
export var MaskedInput = function (props) {
    return React.createElement(IMaskInput, __assign({}, props));
};
export var MaskRange = MaskedRange;
export var MaskMixin = IMaskMixin;
export default MaskedInput;
//# sourceMappingURL=MaskedInput.js.map